import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "dictionary items" }
const _hoisted_2 = {
  key: 0,
  class: "row"
}
const _hoisted_3 = { class: "col-6" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "h3" }, "Colours", -1)
const _hoisted_7 = ["disabled"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-paint-roller" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-copy" }, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "col-6" }
const _hoisted_14 = { class: "card" }
const _hoisted_15 = { class: "card-body" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "h3" }, [
  /*#__PURE__*/_createTextVNode("Conditions "),
  /*#__PURE__*/_createElementVNode("small", { class: "text-muted" }, "(Additional)")
], -1)
const _hoisted_17 = ["disabled"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-paint-roller" }, null, -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = ["disabled"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-copy" }, null, -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 1,
  class: "row mt-3"
}
const _hoisted_24 = { class: "col-6" }
const _hoisted_25 = { class: "card" }
const _hoisted_26 = { class: "card-body" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "h3" }, "Constituents", -1)
const _hoisted_28 = ["disabled"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-paint-roller" }, null, -1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = ["disabled"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-copy" }, null, -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = { class: "col-6" }
const _hoisted_35 = { class: "card" }
const _hoisted_36 = { class: "card-body" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { class: "h3" }, "Makes", -1)
const _hoisted_38 = ["disabled"]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-paint-roller" }, null, -1)
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = ["disabled"]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-copy" }, null, -1)
const _hoisted_43 = [
  _hoisted_42
]

import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { useToast } from "vue-toastification";
import { CustomerDictionaryState } from '@/store/customerdictionary/types';
import SectionTypeSelector from './partials/SectionTypeSelector.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DictionaryItems',
  setup(__props) {

const store = useStore();
const toasted = useToast();

const dictionaryState = computed(() => store.state.customerdictionary as CustomerDictionaryState);
const hasActiveItem = computed(() => store.getters['customerdictionary/hasActiveItem']);
const miscItemColours = computed(() => store.getters['customerdictionary/miscItemColours']);
const miscItemConditions = computed(() => store.getters['customerdictionary/miscItemConditions']);
const miscItemConstituents = computed(() => store.getters['customerdictionary/miscItemConstituents']);
const miscItemMakes = computed(() => store.getters['customerdictionary/miscItemMakes']);

const itemColours = computed({
  get: () => dictionaryState.value.activeItem.colours,
  set: (val: string[]) => store.dispatch('customerdictionary/setColours', val)
});

const itemConditions = computed({
  get: () => dictionaryState.value.activeItem.conditions.additional,
  set: (val: string[]) => store.dispatch('customerdictionary/setConditions', val)
});

const itemConstituents = computed({
  get: () => dictionaryState.value.activeItem.constituents,
  set: (val: string[]) => store.dispatch('customerdictionary/setConstituents', val)
});

const itemMakes = computed({
  get: () => dictionaryState.value.activeItem.makes,
  set: (val: string[]) => store.dispatch('customerdictionary/setMakes', val)
});

const addColour = (val: string) => {
  itemColours.value = itemColours.value.concat(val);
};

const copyColours = () => {
  store.commit('customerdictionary/setClipboardColours', itemColours.value);
  toasted.success("Copied Colours");
};

const pasteColours = () => {
  itemColours.value = dictionaryState.value.clipboardColours;
};

const addCondition = (val: string) => {
  itemConditions.value = itemConditions.value.concat(val);
};

const copyConditions = () => {
  store.commit('customerdictionary/setClipboardConditions', itemConditions.value);
  toasted.success("Copied Conditions");
};

const pasteConditions = () => {
  itemConditions.value = dictionaryState.value.clipboardConditions;
};

const addConstituent = (val: string) => {
  itemConstituents.value = itemConstituents.value.concat(val);
};

const copyConstituents = () => {
  store.commit('customerdictionary/setClipboardConstituents', itemConstituents.value);
  toasted.success("Copied Constituents");
};

const pasteConstituents = () => {
  itemConstituents.value = dictionaryState.value.clipboardConstituents;
};

const addMake = (val: string) => {
  itemMakes.value = itemMakes.value.concat(val);
};

const copyMakes = () => {
  store.commit('customerdictionary/setClipboardMakes', itemMakes.value);
  toasted.success("Copied Makes");
};

const pasteMakes = () => {
  itemMakes.value = dictionaryState.value.clipboardMakes;
};

return (_ctx: any,_cache: any) => {
  const _component_multiselect_text = _resolveComponent("multiselect-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SectionTypeSelector, {
      showSections: true,
      showTypes: true,
      showItems: true
    }),
    (hasActiveItem.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("fieldset", null, [
                  _hoisted_6,
                  _createElementVNode("button", {
                    class: "btn btn-sm btn-outline-primary float-right ml-2",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (pasteColours())),
                    disabled: !dictionaryState.value.clipboardColours.length,
                    title: "Paste"
                  }, _hoisted_9, 8, _hoisted_7),
                  _createElementVNode("button", {
                    class: "btn btn-sm btn-outline-primary float-right ml-2",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (copyColours())),
                    disabled: !itemColours.value.length,
                    title: "Copy"
                  }, _hoisted_12, 8, _hoisted_10),
                  _createVNode(_component_multiselect_text, {
                    modelValue: itemColours.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((itemColours).value = $event)),
                    options: miscItemColours.value,
                    multiple: "",
                    "close-on-select": false,
                    allowEmpty: true,
                    taggable: "",
                    onTag: addColour
                  }, null, 8, ["modelValue", "options"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("fieldset", null, [
                  _hoisted_16,
                  _createElementVNode("button", {
                    class: "btn btn-sm btn-outline-primary float-right ml-2",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (pasteConditions())),
                    disabled: !dictionaryState.value.clipboardConditions.length,
                    title: "Paste"
                  }, _hoisted_19, 8, _hoisted_17),
                  _createElementVNode("button", {
                    class: "btn btn-sm btn-outline-primary float-right ml-2",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (copyConditions())),
                    disabled: !itemConditions.value.length,
                    title: "Copy"
                  }, _hoisted_22, 8, _hoisted_20),
                  _createVNode(_component_multiselect_text, {
                    modelValue: itemConditions.value,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((itemConditions).value = $event)),
                    options: miscItemConditions.value,
                    multiple: "",
                    "close-on-select": false,
                    allowEmpty: true,
                    taggable: "",
                    onTag: addCondition
                  }, null, 8, ["modelValue", "options"])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (hasActiveItem.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("fieldset", null, [
                  _hoisted_27,
                  _createElementVNode("button", {
                    class: "btn btn-sm btn-outline-primary float-right ml-2",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (pasteConstituents())),
                    disabled: !dictionaryState.value.clipboardConstituents.length,
                    title: "Paste"
                  }, _hoisted_30, 8, _hoisted_28),
                  _createElementVNode("button", {
                    class: "btn btn-sm btn-outline-primary float-right ml-2",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (copyConstituents())),
                    disabled: !itemConstituents.value.length,
                    title: "Copy"
                  }, _hoisted_33, 8, _hoisted_31),
                  _createVNode(_component_multiselect_text, {
                    modelValue: itemConstituents.value,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((itemConstituents).value = $event)),
                    options: miscItemConstituents.value,
                    multiple: "",
                    "close-on-select": false,
                    allowEmpty: true,
                    taggable: "",
                    onTag: addConstituent
                  }, null, 8, ["modelValue", "options"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("fieldset", null, [
                  _hoisted_37,
                  _createElementVNode("button", {
                    class: "btn btn-sm btn-outline-primary float-right ml-2",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (pasteMakes())),
                    disabled: !dictionaryState.value.clipboardMakes.length,
                    title: "Paste"
                  }, _hoisted_40, 8, _hoisted_38),
                  _createElementVNode("button", {
                    class: "btn btn-sm btn-outline-primary float-right ml-2",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (copyMakes())),
                    disabled: !itemMakes.value.length,
                    title: "Copy"
                  }, _hoisted_43, 8, _hoisted_41),
                  _createVNode(_component_multiselect_text, {
                    modelValue: itemMakes.value,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((itemMakes).value = $event)),
                    options: miscItemMakes.value,
                    multiple: "",
                    "close-on-select": false,
                    allowEmpty: true,
                    taggable: "",
                    onTag: addMake
                  }, null, 8, ["modelValue", "options"])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})